import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import './doctorefacet.scss'

export default function DoctorFacetSearch(props) {
  const [serviceText, setServiceText] = useState('Service')
  const doctorDeptlist = [
    { id: 'anesthesiology', name: 'Anesthesiology' },
    { id: 'cardiology', name: 'Cardiology' },
    { id: 'dermatology', name: 'Dermatology' },
    { id: 'diabetology', name: 'Diabetologist' },
    { id: 'dentist', name: 'Dentist' },
    { id: 'emergency-medicine', name: 'Emergency Medicine' },
    { id: 'endocrinology', name: 'Endocrinology' },
    { id: 'ent-otolaryngology', name: 'ENT (Otolaryngology)' },
    { id: 'gastroenterology', name: 'Gastroenterology' },
    { id: 'general-medicine', name: 'General Medicine' },
    { id: 'gynaecologist', name: 'Gynaecologist' },
    { id: 'general-physician', name: 'General Physician' },
    { id: 'geriatrics', name: 'Geriatrics' },
    { id: 'gynecology-obstetrics', name: 'Gynecology and Obstetrics' },
    { id: 'hematology', name: 'Hematology' },
    { id: 'infectious-diseases', name: 'Infectious Diseases' },
    { id: 'nephrology', name: 'Nephrologist' },
    { id: 'neurology', name: 'Neurologist' },
    { id: 'oncology', name: 'Oncologist' },
    { id: 'ophthalmology', name: 'Ophthalmologist' },
    { id: 'orthopedics', name: 'Orthopedics' },
    { id: 'pathology', name: 'Pathology' },
    { id: 'pediatrics', name: 'Pediatrics' },
    { id: 'plastic-surgery', name: 'Plastic Surgery' },
    { id: 'psychiatry', name: 'Psychiatry' },
    { id: 'pulmonology', name: 'Pulmonologist' },
    { id: 'radiology', name: 'Radiology' },
    {
      id: 'rehabilitation-medicine',
      name: 'Rehabilitation Medicine (Physical Medicine)',
    },
    { id: 'rheumatology', name: 'Rheumatology' },
    { id: 'sports-medicine', name: 'Sports Medicine' },
    { id: 'urology', name: 'Urology' },
    { id: 'vascular-surgery', name: 'Vascular Surgery' },
  ]
  const handleItemClick = (id) => {
    const selectedText = doctorDeptlist.find((item)=>{
      return item.id === id;
    })
    setServiceText(selectedText.name);
    props.selectedItem(id)
  }
  return (
    <>
      <div className="facet-filter">
        <p>Filters</p>
        <div class="nav-item dropdown">
          <button
            className="nav-link dropdown-toggle"
            id="specialityDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            eventKey="3"
          >
            {serviceText}
          </button>
          <ul className="dropdown-menu" aria-labelledby="specialityDropdown">
            {doctorDeptlist.map((item) => (
              <li
                className="dropdown-item"
                data-id={item.id}
                onClick={(e) => {
                  e.preventDefault()
                  handleItemClick(item.id)
                }}
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}
